<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data }: ContentBlockComponentProps<ContentType.UnorderedList> = $props();
</script>

<div class="max-w-screen-md mx-auto w-full">
	<ul class="flex list-none flex-col gap-4">
		{#each data.items as { id, text } (id)}
			<li class="flex items-center gap-4">
				<span class="bg-cmcprimary inline-block w-6 h-[0.15625rem] shrink-0"></span>
				<span class="text-lg font-semibold md:text-[1.5rem] leading-none">
					<Formatted {text} />
				</span>
			</li>
		{/each}
	</ul>
</div>
